import React from 'react';
import { Button } from 'react-bootstrap';
import LoadingPlaceholder from './../../shared/LoadingPlaceholder';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

import './poicard.scss';

class PoiCard extends React.Component {

  constructor(props) {
    super(props);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleButtonClick() {
    if (this.props.gaEvent) {
      ReactGA.event(this.props.gaEvent);
      ReactGA4.event({...this.props.gaEvent, action: this.props.gaEvent.category, category: this.props.gaEvent.action});
    }
    window.open(this.props.buttonLink, '_blank');
  }

  render() {

    const style = { backgroundImage: `url(${this.props.backgroundImage})` };

    const button = (
      <Button className="shared-poicard-component__link" onClick={this.handleButtonClick}>
        <strong>{this.props.buttonText}</strong>
      </Button>
    );

    return (
      <div className="shared-poicard-component" style={style}>
        <div className="shared-poicard-component__overlay">
          <h2 className="shared-poicard-component__title">
            <strong>
              <LoadingPlaceholder ready={!!this.props.htmlText} text-align="center">
                {this.props.title || <span></span>}
              </LoadingPlaceholder>
            </strong>
          </h2>
          <div className="shared-poicard-component__content">
            <LoadingPlaceholder ready={!!this.props.htmlText} text-align="center">
              {this.props.htmlText || <span></span>}
            </LoadingPlaceholder>
          </div>

          {this.props.buttonText && this.props.buttonLink ? button : null}

        </div>
      </div>
    );
  }
}

PoiCard.displayName = 'PagesSharedPoiCard';
PoiCard.propTypes = {};
PoiCard.defaultProps = {};

export default PoiCard;



// WEBPACK FOOTER //
// ./components/pages/shared/PoiCard.js